import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useEditInputStyles = makeStyles((theme) => ({
  textfieldRoot: {
    marginBottom: 12
  },
  email: {
    maxWidth: 558
  },
  InputRoot: {
    '&:first-child': {
      marginBottom: 12
    },
    '& .MuiOutlinedInput-input': {
      padding: '10.5px 14px'
    },
    '&.MuiOutlinedInput-multiline': {
      padding: 4
    }
  },
  input: {
    '&::placeholder': {
      ...theme.typography.body2
    }
  },
  buttonRoot: {
    maxWidth: 124,
    height: 42
  },
  certificationBtn: {
    maxWidth: 124,
    marginLeft: 8,
    '&:first-child': {
      marginRight: 8
    }
  },
  buttonContainer: {
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      marginTop: 36,
      justifyContent: 'center',
      flexWrap: 'nowrap'
    }
  },
  button: {
    maxWidth: 124,
    '&:first-child': {
      marginRight: 8
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%'
    }
  },
  outlinedSecondary: {
    color: colorSet.gray700
  }
}));
